// ----------------------------------------------------------------------------
// Component: Anchor Links
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------

// Styles
import './_anchor-links.scss';

// -------------------------------------
// Variables
// -------------------------------------
var ANCHOR_SELECTOR = '.anchor-links-wrap';
var ANCHOR_LINK_SELECTOR = '.anchor-link';
var SHOPIFY_HEADER = '#shopify-section-header';
var ANCHOR_LINKS_CONTAINER = '.anchor-links-container';
var anchorWrap = document.querySelector(ANCHOR_SELECTOR);
var anchorLinks = document.querySelectorAll(ANCHOR_LINK_SELECTOR);
var header = document.querySelector(SHOPIFY_HEADER);
var anchorOnScroll = () => {
  var isHeaderSticky = document.body.classList.contains('is-header-sticky');
  if (isHeaderSticky && header) {
    anchorWrap.querySelector(ANCHOR_LINKS_CONTAINER).style.top = "".concat(header.offsetHeight, "px");
  } else {
    anchorWrap.querySelector(ANCHOR_LINKS_CONTAINER).style.top = null;
  }
};
document.addEventListener('DOMContentLoaded', () => {
  var _header$offsetHeight;
  var headerHeight = (_header$offsetHeight = header === null || header === void 0 ? void 0 : header.offsetHeight) !== null && _header$offsetHeight !== void 0 ? _header$offsetHeight : 60;
  var sections = [...anchorLinks].map(link => document.querySelector(link.getAttribute('href'))).filter(Boolean);
  if (anchorWrap) {
    var observerSticky = new IntersectionObserver(_ref => {
      var [entry] = _ref;
      return anchorWrap.classList.toggle('sticky', !entry.isIntersecting);
    }, {
      rootMargin: "-".concat(headerHeight, "px 0px 0px 0px"),
      threshold: 0
    });
    observerSticky.observe(anchorWrap);
  }
  if (anchorWrap && anchorLinks && sections.length) {
    var observerSections = new IntersectionObserver(entries => {
      entries.forEach(_ref2 => {
        var {
          target,
          isIntersecting
        } = _ref2;
        var link = document.querySelector(".anchor-link[href='#".concat(target.id, "']"));
        if (isIntersecting) {
          anchorLinks.forEach(a => a.classList.remove('active'));
          link === null || link === void 0 || link.classList.add('active');
          if (window.innerWidth <= 768) {
            link === null || link === void 0 || link.scrollIntoView({
              behavior: 'smooth',
              inline: 'center'
            });
          }
        }
      });
    }, {
      rootMargin: "-".concat(headerHeight + 10, "px 0px -50% 0px"),
      threshold: 0.1
    });
    sections.forEach(section => observerSections.observe(section));
    if (anchorWrap && anchorLinks) {
      anchorLinks.forEach(link => link.addEventListener('click', e => {
        e.preventDefault();
        var targetId = link.getAttribute('href').slice(1);
        var targetSection = document.getElementById(targetId);
        if (targetSection) {
          var yOffset = -headerHeight - 10;
          var y = targetSection.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({
            top: y,
            behavior: 'smooth'
          });
        }
      }));
    }
    window.addEventListener('scroll', anchorOnScroll);
  }
});